import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import {
  format,
  addDays,
  getWeeksInMonth,
  getDate,
  startOfMonth,
  getDaysInMonth,
  startOfWeek,
  setDay,
  getDay,
  getMonth,
} from "date-fns";
import { he } from "date-fns/locale";
import Text from "../Text";
import { useEffect, useState } from "react";

const DayDiv = styled.div(({ theme, selected }) => ({
  width: "100%",
  color: selected ? "#FFFFFF" : theme.color.text,
}));

const StandardDiv = styled.div(() => ({
  borderRadius: 4,
  border: `1px solid #E86520`,
  height: 30,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  fontSize: 14,
  margin: "5px 0",
  color: "#E86520",
}));

const HoursDiv = styled.div(({ width, theme }) => ({
  borderRadius: 4,
  background: "#E86520",
  height: 22,
  width: width,
  margin: 2,
  color: theme.color.white,
  fontSize: 14,
  padding: 2,
  lineHeight: "17px",
}));

const ABSDiv = styled.div(({ width, theme, color }) => ({
  borderRadius: 4,
  background: color,
  height: 22,
  width: width,
  color: theme.color.white,
  fontSize: 14,
  padding: 2,
  margin: "5px 0",
}));

const DotDiv = styled.div(({ color }) => ({
  borderRadius: 50,
  background: color,
  height: 5,
  width: 5,
  backgroundColor: color,
  alignItems: "center",
  marginInline: 1,
  display: "flex",
}));

const Header = ({ days }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      {days.map((day, index) => {
        return (
          <DayDiv>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingBottom: 10,
                justifyContent: "center",
              }}>
              <div
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 29,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                {format(day, "EEEEE", { locale: he })}{" "}
              </div>
            </div>
          </DayDiv>
        );
      })}
    </div>
  );
};

const Day = ({ day, date, data, setSelectedDate }) => {
  const theme = useTheme();
  const inDate = getMonth(day) === getMonth(date);
  return (
    <DayDiv selected={getDate(day) === getDate(date)} style={{}}>
      <div
        style={{
          color: inDate ? theme.color.text : theme.color.gray,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: 10,
          justifyContent: "center",
        }}>
        <div
          onClick={() => setSelectedDate(day)}
          style={{
            width: 30,
            height: 30,
            borderRadius: 29,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            backgroundColor:
              getDate(day) === getDate(date) ? theme.color.blue : "transparent",
            color:
              getDate(day) === getDate(date)
                ? theme.color.white
                : theme.color.text,
          }}>
          {getDate(day)}
        </div>
        {inDate && (
          <div
            style={{
              width: 30,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 2,
            }}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}>
              {data?.STANDARD > 0 && (
                <div style={{ flexBasis: "30%" }}>
                  <DotDiv color="#E86520" />
                </div>
              )}
              {data?.EXTRA > 0 && (
                <div style={{ flexBasis: "30%" }}>
                  <DotDiv color="#4A69A6" />
                </div>
              )}
              {data?.VAC > 0 && (
                <div style={{ flexBasis: "30%" }}>
                  <DotDiv color="#E214E7" />
                </div>
              )}
              {data?.ILL > 0 && (
                <div style={{ flexBasis: "30%" }}>
                  <DotDiv color="#E7B814" />
                </div>
              )}
              {data?.SERV > 0 && (
                <div style={{ flexBasis: "30%" }}>
                  <DotDiv color="#293041" />
                </div>
              )}
              {!!data?.HOLIDAYDES && (
                <div style={{ flexBasis: "30%" }}>
                  <DotDiv color="#63D09C" />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </DayDiv>
  );
};

const Week = ({ days, date, setSelectedDate }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      {days.map((day, index) => {
        return (
          <Day
            day={day.day}
            key={index}
            date={date}
            data={day.data}
            setSelectedDate={setSelectedDate}
          />
        );
      })}
    </div>
  );
};

const MobileCalender = ({ date, data, setSelectedDate }) => {
  const [dayData, setDayData] = useState(null);
  const { t } = useTranslation("month_reports");
  const days = [];
  const weeks = [];
  const daysInMonthArray = [];

  let startDate = startOfMonth(date);
  const firstSunday = setDay(startDate, 0, { weekStartsOn: getDay(startDate) });
  const dayInMonth = getDaysInMonth(date);
  const startWeek = startOfWeek(startDate);

  useEffect(() => {
    let dayData = data?.find((report) => {
      return getDate(new Date(report.CURDATE)) === getDate(new Date(date));
    });
    setDayData(dayData);
    // eslint-disable-next-line
  }, [date]);

  for (let i = 0; i < 7; i++) {
    days.push(addDays(firstSunday, i));
  }

  for (let i = 0; i < dayInMonth; i++) {
    daysInMonthArray.push(addDays(startDate, i));
  }

  for (let i = 0; i < getWeeksInMonth(startDate); i++) {
    weeks.push(addDays(startWeek, i * 7));
  }

  return (
    <div style={{ alignSelf: "center", padding: 20 }}>
      <Header days={days}></Header>
      <div
        style={{
          overflow: "auto",
        }}>
        {weeks.map((week, index) => {
          let innerDays = [];

          for (let i = 0; i < 7; i++) {
            let day = addDays(week, i);
            let dayData = data?.find((report) => {
              return (
                getDate(new Date(report.CURDATE)) === getDate(new Date(day))
              );
            });
            innerDays.push({ day: day, data: dayData });
          }
          return (
            <Week
              key={index}
              days={innerDays}
              date={date}
              setSelectedDate={setSelectedDate}
            />
          );
        })}
      </div>
      <div>
        <Text style={{ fontSize: 16, fontWeight: 600 }}>
          {`${format(date, "MMMM", { locale: he })} ${format(date, "d", {
            locale: he,
          })} `}
        </Text>
        <div>
          {dayData?.STANDARD > 0 && (
            <StandardDiv>
              {dayData?.HOURS > 0 && (
                <HoursDiv
                  width={`${
                    ((dayData?.EXTRA > 0
                      ? dayData?.HOURS - dayData?.EXTRA
                      : dayData?.HOURS) /
                      dayData?.STANDARD) *
                    100
                  }%`}>
                  {t("hours_hours", {
                    hours:
                      dayData?.EXTRA > 0
                        ? dayData?.HOURS - dayData?.EXTRA
                        : dayData?.HOURS,
                  })}
                </HoursDiv>
              )}
              {dayData?.HOURS < dayData?.STANDARD && (
                <div style={{ padding: 2, whiteSpace: "nowrap" }}>
                  {t("standard_hours", { hours: dayData?.STANDARD })}
                </div>
              )}
            </StandardDiv>
          )}
          {dayData?.EXTRA > 0 && (
            <ABSDiv color="#4A69A6">
              {t("extra_hours", { hours: dayData?.EXTRA })}
            </ABSDiv>
          )}
          {dayData?.VAC > 0 && (
            <ABSDiv color="#E214E7">
              {t("vacation_hours", { hours: dayData?.VAC })}
            </ABSDiv>
          )}
          {dayData?.ILL > 0 && (
            <ABSDiv color="#E7B814">
              {t("illnace_hours", { hours: dayData?.ILL })}
            </ABSDiv>
          )}
          {data?.SERV > 0 && (
            <ABSDiv color="#293041">
              {t("serveice_hours", { hours: dayData?.SERV })}
            </ABSDiv>
          )}
          {!!dayData?.HOLIDAYDES && (
            <ABSDiv color="#63D09C">{dayData?.HOLIDAYDES}</ABSDiv>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileCalender;
